export const defaultValues = {
  title: '',
  accountLivestreamId: [],
  startedAt: null,
  endedAt: null,
  hostId: [],
  studioId: '',
  operatorId: [],
  selectedDate: new Date(),
};
